import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { CoachingInsight } from '../../../components/coachingInsight/CoachingInsight';
import { COACHING_INSIGHTS_CONFIG, ROLES } from '../../../constants';
import { selectCurrentEmpid, selectCurrentUserManagerLevel } from '../../../pages/login/authSlice';
import {
    useGetOneUpTeamleadsPcQuery,
    useGetTwoUpManagersPcQuery,
} from '../coachingSlice';
import { useGetParentClientsByConfigQuery } from '../../../components/coachingInsight/coachingInsightFeedback/agentFilter/agentFilterSlice';
import { useGetCoachingInsightConfigQuery } from '../../../components/coachingInsight/CoachingInsightSlice';

interface CoachingCallInsightProps {
    userParentClient: any[];
    fromTab?: string;
}

export const CoachingCallInsight = (props:CoachingCallInsightProps) => {
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [selectedTLList, setSelectedTLList] = useState<any>([]);
    const [selectedParentClient, setSelectedParentClient] = useState<any[]>(props?.userParentClient);
    const [selectedMngr, setSelectedMngr] = useState('');
    const [managersList, setManagersList] = useState([]);
    const [aggregationPeriod, setAggregationPeriod] = useState<'weekly' | 'monthly'>('weekly');
    
    const { data: allParentClientsData } = useGetParentClientsByConfigQuery({        
        configCode: COACHING_INSIGHTS_CONFIG,
    });
    const { data: managersData } = useGetTwoUpManagersPcQuery(
        {
            parentClientIds: selectedParentClient,
        },
        {
            skip: !selectedParentClient || selectedParentClient.length <= 0,
        }
    );
    const { data: directReportees } = useGetOneUpTeamleadsPcQuery(
        {
            managerNumber: parseInt(selectedMngr, 10),
            parentClientIds: selectedParentClient,
        },
        {
            skip: !selectedMngr || !selectedParentClient || selectedParentClient.length <= 0,
        }
    );

    // Fetch coaching insight config based on first parent client ID
    const { data: coachingInsightConfig } = useGetCoachingInsightConfigQuery(
        {
            parentClientId: selectedParentClient?.[0],
        },
        {
            skip: !selectedParentClient || selectedParentClient.length === 0,
        }
    );
    const onParentClientChange = (e: any) => {
        setSelectedParentClient(e.value);
        setSelectedMngr('');
        if (selectedParentClient&&selectedParentClient.length > 0) {
            setSelectedMngr('');
            setManagersList([]);
        }
    };
    
    useEffect(() => {
        if (props?.userParentClient && props?.userParentClient.length > 0){
            const isIdInList = allParentClientsData?.data?.some((pc:any) => pc.parent_client_id === props?.userParentClient?.[0]);  
            setSelectedParentClient(isIdInList ? props?.userParentClient : []);
        }
        else
            setSelectedParentClient([]);
        
    }, [props?.userParentClient,allParentClientsData]);

    useEffect(() => {
        if (managersData?.data.length > 0) {
            setManagersList(managersData?.data);
            if(localStorage.getItem('insightsSelectedManager')){
                setSelectedMngr(localStorage.getItem('insightsSelectedManager') as string);
            }
            else if (ROLES.Supervisor2AndAbove.includes(userManagerLevel)) {
                setSelectedMngr(loggedEmpNum);
            }
        }
    }, [managersData]);

    useEffect(() => {
        if (directReportees?.data?.length > 0) {
            setSelectedTLList(directReportees);
        }
    }, [directReportees]);

    // Set aggregation period from config
    useEffect(() => {
        if (coachingInsightConfig?.data) {
            const period = coachingInsightConfig.data.data_aggregation_period;
            if (period === 'monthly' || period === 'weekly') {
                setAggregationPeriod(period);
                // Clear date selections when config changes
                localStorage.removeItem('insightsSelectedDateRange');
                localStorage.removeItem('insightsSelectedMonth');
            }
        }
    }, [coachingInsightConfig]);


    return (
        <div>
            {ROLES.Supervisor2AndAbove.includes(userManagerLevel) &&(
                <div className="row">
                    {/* <div className="row mt-4">
                        <h5>Executive Director</h5>
                        <div className="col-md-6" style={{ fontSize: '17px', fontWeight: 400 }}>
                            {loggedEmpUser}
                        </div>
                    </div> */}
                    <div className="row mt-4">
                        <div className="col-md-3">
                            <div className="content">
                                <label htmlFor="parentClient">Parent Client</label>
                                <MultiSelect
                                    id="parentClient"                                    
                                    placeholder="Select Parent Client"
                                    options={allParentClientsData?.data}
                                    optionValue={'parent_client_id'}
                                    optionLabel={'parent_client_name'}
                                    value={selectedParentClient}
                                    onChange={onParentClientChange}
                                    maxSelectedLabels={3}
                                    className="custom-dropdown"
                                    disabled={ROLES.SupervisorOrOnlyManager.includes(userManagerLevel)}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="content">
                                <label htmlFor="select-mngr">Select Manager</label>
                                <Dropdown
                                    id="select-mngr"
                                    placeholder="Select Manager"
                                    className="custom-dropdown"
                                    options={managersList}
                                    optionValue={'employee_number'}
                                    optionLabel={'employee_name'}
                                    value={selectedMngr}
                                    onChange={(e) => {
                                        setSelectedMngr(e.target.value);
                                        localStorage.setItem('insightsSelectedManager', e.target.value);
                                        localStorage.removeItem('insightsSelectedTL');
                                        localStorage.removeItem('insightsSelectedAgent');
                                    }}
                                    filter
                                    disabled={ROLES.Supervisor.includes(userManagerLevel)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Divider />
            <CoachingInsight
                selectedTLList={selectedTLList}
                selectedParentClient={selectedParentClient}
                selectedManager={selectedMngr}
                fromTab={props?.fromTab}
                data_aggregation_period={aggregationPeriod}
            />
        </div>
    );
};
